import { z } from "zod";

export const emailSchema = z
  .string()
  .email("Bitte geben Sie eine gültige E-Mail-Adresse ein");
